import { Helmet } from "react-helmet-async";
import { FiCheckCircle, FiZap, FiUser, FiEye, FiHeadphones, FiLayers, FiArrowRight } from "react-icons/fi";
import { FaMobileAlt, FaSearch, FaShieldAlt, FaChartLine } from "react-icons/fa";

const PaketCard = ({ title, description, features, price, icon }) => (
  <div className="col-md-6">
    <div className="card h-100 border-0 shadow-sm hover-scale">
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
            {icon}
          </div>
          <h3 className="card-title mb-0">{title}</h3>
        </div>
        <p className="card-text text-muted">{description}</p>
        <ul className="list-unstyled">
          {features.map((item, i) => (
            <li key={i} className="mb-2">
              <FiCheckCircle className="text-primary me-2" />
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="card-footer bg-white border-0">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="text-primary mb-0">{price} TL</h4>
          <button className="btn btn-sm btn-outline-primary">
            Detaylı Bilgi <FiArrowRight size={14} />
          </button>
        </div>
        <small className="text-muted">+ KDV</small>
      </div>
    </div>
  </div>
);

const NedenCard = ({ title, text, icon }) => (
  <div className="col-md-4">
    <div className="p-4 border rounded-3 h-100 shadow-sm hover-scale bg-white">
      <div className="bg-primary bg-opacity-10 p-3 rounded-circle d-inline-block mb-3">
        {icon}
      </div>
      <h5>{title}</h5>
      <p className="text-muted">{text}</p>
    </div>
  </div>
);

const FeatureCard = ({ title, text, icon }) => (
  <div className="col-md-3">
    <div className="p-4 border rounded-3 text-center h-100 bg-white hover-scale">
      {icon}
      <h5 className="mt-3">{title}</h5>
      <p className="text-muted small">{text}</p>
    </div>
  </div>
);

const Kampanya = () => (
  <>
    <Helmet>
      <title>Kampanyalar - Hacı Ali Kara | Web Tasarım Paketleri</title>
      <link rel="canonical" href="https://hacialiikara.com/kampanya" />
      <meta
        name="description"
        content="Size özel web tasarım çözümlerimi keşfedin. Her projeye kişisel ilgi ve özenle yaklaşıyorum."
      />
      <meta name="robots" content="index, follow" />
    </Helmet>

    <div className="container mb-2">
      {/* Hero Section */}
      <section className="text-center mb-5 pt-4">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1 className="display-5 fw-bold mb-4">Dijital Varlığınızı <span className="text-primary">Profesyonelce</span> Tasarlıyorum</h1>
            <p className="lead text-muted">İşinizin ihtiyaçlarına özel, modern ve etkileyici web tasarım çözümleri sunuyorum.</p>
            <div className="d-flex gap-2 justify-content-center mt-4">
              <a href="#paketler" className="btn btn-primary btn-lg px-4">Paketleri İncele</a>
              <a href="#iletisim" className="btn btn-outline-primary btn-lg px-4">Ücretsiz Danışmanlık</a>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              src="/resimler/kampanya/tasarim.png"
              alt="Profesyonel Web Tasarım"
              className="img-fluid hero-img"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <div className="section-divider"></div>

      {/* Paketler */}
      <section id="paketler" className="mb-5 pt-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">Web Tasarım <span className="text-primary">Paketlerim</span></h2>
          <p className="text-muted mx-auto" style={{maxWidth: "700px"}}>İhtiyaçlarınıza uygun, esnek ve profesyonel çözümler sunuyorum</p>
        </div>

        <div className="row g-4">
          <PaketCard
            title="Landing Page"
            description="Hedef kitlenizi etkileyecek, dönüşüm odaklı tek sayfalık profesyonel web sitesi çözümü."
            features={[
              "12 Sayfa Özgün Tasarım",
              "SEO ve Hız Optimizasyonu",
              "Tüm Cihazlara Tam Uyum",
              "Admin Panel Eğitimi",
              "1 Yıl Teknik Destek",
              "Google Analytics Entegrasyonu"
            ]}
            price="4000"
            icon={<FiLayers className="text-primary" size={24} />}
          />

          <PaketCard
            title="E-Ticaret Sitesi"
            description="Ürünlerinizi kolayca yönetebileceğiniz, güvenli ve kullanıcı dostu e-ticaret çözümü."
            features={[
              "Kolay Ürün Yönetimi",
              "Gelişmiş Arama ve Filtreleme",
              "SEO Optimizasyonu",
              "Güvenli Ödeme Sistemleri",
              "Mobil Uyumlu Tasarım",
              "Stok ve Sipariş Yönetimi"
            ]}
            price="6000"
            icon={<FaMobileAlt className="text-primary" size={24} />}
          />
        </div>
      </section>

      {/* Ekstra Özellikler */}
      <section className="my-5 py-5">
        <div className="row g-4">
          <FeatureCard
            title="SEO Optimizasyonu"
            text="Google'da üst sıralarda çıkmanız için optimize ediyorum"
            icon={<FaSearch className="feature-icon" />}
          />
          <FeatureCard
            title="Hızlı Yükleme"
            text="Yüksek performanslı, hızlı açılan siteler"
            icon={<FiZap className="feature-icon" />}
          />
          <FeatureCard
            title="Güvenlik"
            text="Güvenliği ön planda tutan çözümler"
            icon={<FaShieldAlt className="feature-icon" />}
          />
          <FeatureCard
            title="Analiz"
            text="Veriye dayalı iyileştirmeler"
            icon={<FaChartLine className="feature-icon" />}
          />
        </div>
      </section>

      {/* Neden Benimle Çalışmalısınız */}
      <section className="my-5 py-5 bg-light rounded-4">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Neden <span className="text-primary">Benimle</span> Çalışmalısınız?</h2>
            <p className="text-muted">Profesyonel çözümler ve kişiye özel yaklaşım</p>
          </div>
          <div className="row g-4">
            <NedenCard
              title="Kişiye Özel Çözümler"
              text="Standart şablonlar değil, işinize özel tasarımlar sunuyorum."
              icon={<FiUser className="text-primary" size={20} />}
            />
            <NedenCard
              title="Şeffaf Süreç"
              text="Proje aşamalarını anlık takip edebilir, geri bildirimde bulunabilirsiniz."
              icon={<FiEye className="text-primary" size={20} />}
            />
            <NedenCard
              title="Sürekli Destek"
              text="Teslim sonrasında da yanınızdayım, sorularınızı cevaplıyorum."
              icon={<FiHeadphones className="text-primary" size={20} />}
            />
          </div>
        </div>
      </section>

      {/* Süreç Adımları */}
      <section className="my-5 py-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Profesyonel <span className="text-primary">Çalışma</span> Sürecim</h2>
          <p className="text-muted">Projenizin başarıya ulaşması için izlediğim adımlar</p>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="text-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '70px', height: '70px'}}>
                <span className="text-primary fw-bold">1</span>
              </div>
              <h5>Keşif ve Analiz</h5>
              <p className="text-muted small">İhtiyaçlarınızı belirliyor ve detaylı analiz yapıyorum</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '70px', height: '70px'}}>
                <span className="text-primary fw-bold">2</span>
              </div>
              <h5>Tasarım</h5>
              <p className="text-muted small">Özgün ve modern tasarım konseptleri oluşturuyorum</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '70px', height: '70px'}}>
                <span className="text-primary fw-bold">3</span>
              </div>
              <h5>Geliştirme</h5>
              <p className="text-muted small">En son teknolojilerle profesyonel kodlama yapıyorum</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="text-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '70px', height: '70px'}}>
                <span className="text-primary fw-bold">4</span>
              </div>
              <h5>Test ve Teslim</h5>
              <p className="text-muted small">Kapsamlı testler sonrası projeyi teslim ediyorum</p>
            </div>
          </div>
        </div>
      </section>

      {/* İletişim CTA */}
      <section id="iletisim" className="my-5 py-5">
        <div className="cta-section p-5 text-center">
          <h2 className="fw-bold mb-4">Projenize <span className="text-primary">Başlayalım</span> mı?</h2>
          <p className="lead text-muted mb-5 mx-auto" style={{maxWidth: "600px"}}>Profesyonel web tasarım çözümleriyle işinizi bir adım öne taşıyın. Ücretsiz danışmanlık için şimdi iletişime geçin.</p>
          <a href="/iletisim" className="btn btn-primary btn-lg px-5 py-3">Ücretsiz Danışmanlık Al</a>
        </div>
      </section>
    </div>
  </>
);

export default Kampanya;